import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Home from './page/Home';
import SignIn from './page/SignIn';
import Form from './page/Form';
import Dashboard from './page/Dashboard';
import WebDev1Shn from './page/WebDev1Shn';
import Certificate from './page/Certificate';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/signin' element={<SignIn/>} />
          <Route path='/form' element={<Form/>} />
          <Route path='/dash' element={<Dashboard/>} />
          <Route path='/certificate' element={<Certificate/>} />
          <Route path='/certificate/:id' element={<Certificate/>} />
          <Route path='/course/webdev1shn' element={<WebDev1Shn/>} />
          <Route path='*' element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;